import { appConfig } from '../../constants/app-config';
import { parseDates } from '../../utils/date-utils';
import { isDate } from '../../utils/type-utils';

export const configServiceModule = angular
  .module('Q.services.config-service', [])
  .factory('configService', function ($http, $log, $q) {
    let data = null;
    let loading = null;
    let overrodeDelay;

    return {
      get config() {
        return data || {};
      },
      load(force = false) {
        if (!force && data) {
          return $q.when(data);
        } else {
          let ts = force ? '?' + Date.now() : '';
          if (!loading) {
            loading = $http
              .get(`${appConfig.baseApiRoot}config${ts}`)
              .then((response) => {
                if (!response || !response.data) {
                  return $q.reject();
                }
                data = parseDates(response.data);
                data.timeDiffMS = 0;
                data.ignoreTimeDelay = () => {
                  overrodeDelay = true;
                  data.significantTimeDelay = false;
                };
                if (isDate(data.currentTime)) {
                  data.timeDiffMS = new Date() - data.currentTime;
                  if (!overrodeDelay) {
                    // true if server-client time difference is greater than 5 minutes
                    data.significantTimeDelay =
                      Math.abs(data.timeDiffMS) > 300000;
                  }
                }
                return data;
              })
              .catch((err) => {
                $log.error('Failed to obtain api config', err);
                return $q.reject();
              })
              .finally(() => {
                loading = null;
              });
          }
          return loading;
        }
      },
    };
  });
